import $ from 'jquery';

const jsContainer = () => {
    var wrapper = $('.entry-header-vehicle-range__image-wrapper');
    if (wrapper.length) {
        const bodyWidth = $('body').outerWidth()

        if (window.matchMedia('(min-width: 992px)').matches) {
            wrapper.css({
                width: `calc(${bodyWidth / 2}px`,
                marginRight: `calc(${-bodyWidth / 2}px + 50%)`,
            })
        } else {
            wrapper.css({
                width: `calc(${bodyWidth}px`,
                marginRight: 0,
            })
        }
    }
}

$(window).bind('resize', jsContainer).trigger('resize')

